import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { focusRing, scrollToId } from './landingStyles';

const FinalCta: React.FC = () => {
  return (
    <Box
      component="section"
      aria-labelledby="final-cta-title"
      sx={{
        textAlign: 'center',
        px: { xs: 2, md: 4 },
        py: { xs: 4, md: 6 },
        borderRadius: 3,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
      }}
    >
      <Typography id="final-cta-title" variant="h4" component="h2" sx={{ fontWeight: 800, mb: 1 }}>
        Ready to analyze a deal?
      </Typography>
      <Typography sx={{ mb: 3, opacity: 0.92 }}>
        Start free. No credit card required.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 1.5 }}>
        <Button
          component={RouterLink}
          to="/signup"
          variant="contained"
          size="large"
          sx={{
            bgcolor: 'brand.yellow',
            color: 'brand.navy',
            '&:hover': { bgcolor: 'brand.yellow', filter: 'brightness(0.95)' },
            ...focusRing,
          }}
        >
          Start free
        </Button>
        <Button
          variant="outlined"
          size="large"
          onClick={() => scrollToId('sign-in')}
          sx={{
            borderColor: 'primary.contrastText',
            color: 'primary.contrastText',
            '&:hover': { borderColor: 'brand.yellow', bgcolor: 'transparent' },
            ...focusRing,
          }}
        >
          Sign in
        </Button>
      </Box>
    </Box>
  );
};

export default FinalCta;
